import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../../features/auth";
import type { ITransportHistory } from "../../../models/storeModels/ITransportHistory";
import { convertDate } from "../../../features/dataFormatFunctions/dataFormatter";

function getInitialState(){
    const initialState: ITransportHistory = {
        transportHistoryDrivewaysList: null,
        transportHistoryCurrentTransportId: null,
        transportHistoryCurrentTransportDates: null,
        transportHistoryCurrentTransportDriveways: null,
        transportHistoryChosenDate: convertDate(new Date().toString()),
        transportHistoryChosenDriveways: null,
        transportHistoryShowOnMapButtonClicked: false
    }
    return initialState
}

export const transportHistorySlice = createSlice({
    name: 'transportHistory',
    initialState: getInitialState(),
    reducers: {
        setTransportHistoryDrivewaysList(state, action: PayloadAction<any>) {
            state.transportHistoryDrivewaysList = action.payload
        },
        setTransportHistoryCurrentTransportId(state, action: PayloadAction<any>) {
            state.transportHistoryCurrentTransportId = action.payload
        },
        setTransportHistoryCurrentTransportDates(state, action: PayloadAction<any>) {
            state.transportHistoryCurrentTransportDates = action.payload
        },
        setTransportHistoryChosenDate(state, action: PayloadAction<any>) {
            state.transportHistoryChosenDate = action.payload
        },
        setTransportHistoryCurrentTransportDriveways(state, action: PayloadAction<any>) {
            state.transportHistoryCurrentTransportDriveways = action.payload
        },
        setTransportHistoryChosenDriveways(state, action: PayloadAction<any>) {
            state.transportHistoryChosenDriveways = action.payload
        },
        setTransportHistoryShowOnMapButtonClicked(state, action: PayloadAction<any>) {
            state.transportHistoryShowOnMapButtonClicked = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setTransportHistoryDrivewaysList,
    setTransportHistoryCurrentTransportId,
    setTransportHistoryCurrentTransportDates,
    setTransportHistoryChosenDate,
    setTransportHistoryCurrentTransportDriveways,
    setTransportHistoryChosenDriveways,
    setTransportHistoryShowOnMapButtonClicked
} = transportHistorySlice.actions
export const transportHistoryReducer = transportHistorySlice.reducer;
